import { getAccessToken, mayUseTgSession } from './auth-cookie';

/** Ends the session slightly early, so clock drift never sends a token the server already rejects. */
export const SESSION_EXPIRY_MARGIN_MS = 30_000;

/**
 * Reads `exp` from a JWT access token, in milliseconds. Null when the token carries no
 * readable expiry, in which case only the server can tell.
 */
export function getAccessTokenExpiry(token: string): number | null {
  const payload = token.split('.')[1];

  try {
    // JWTs are base64url, which atob only reads once - and _ are mapped back.
    const { exp } = JSON.parse(atob(payload.replaceAll('-', '+').replaceAll('_', '/'))) as {
      exp?: unknown;
    };
    return typeof exp === 'number' ? exp * 1000 : null;
  } catch {
    // Opaque or malformed token. Never log the error: parse messages quote the token.
    return null;
  }
}

/**
 * True once the legacy token's `exp` (less the margin) has passed, or once the token is gone after this page load
 * had one. A browser that never had a token may hold a TG session: the BFFs answer for it.
 */
export function hasSessionEnded(now = Date.now()): boolean {
  const token = getAccessToken();
  if (!token) {
    return !mayUseTgSession();
  }

  const expiry = getAccessTokenExpiry(token);
  return expiry !== null && now >= expiry - SESSION_EXPIRY_MARGIN_MS;
}
